class AssemblyProductsList extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("AssemblyCategoryDropdown:change", (e) =>
      this.onCategoryChange(e.target.value)
    );
  }

  hideProducts() {
    this.querySelectorAll("[data-category]").forEach(
      (node) => (node.style.display = "none")
    );
  }

  showProducts(category) {
    this.querySelectorAll(`[data-category="${category}"]`).forEach(
      (node) => (node.style.display = "flex")
    );
  }

  selectFirstProduct(category) {
    const product = this.querySelectorAll(`[data-category="${category}"]`)?.[0];

    if (product) {
      product.hideInstructions();
      product.showInstructions(product.dataset.productId);
    }
  }

  onCategoryChange(category) {
    this.hideProducts();
    this.showProducts(category);
    this.selectFirstProduct(category);

    // Update URL params when category changes
    try {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      if (category) {
        params.set("category", category);
      } else {
        params.delete("category");
      }

      // Clear any previously selected product when category changes
      params.delete("product");

      url.search = params.toString();
      window.history.replaceState({}, "", url.toString());
    } catch (e) {
      // Silently fail if URL APIs are not available
      console.error(e);
    }
  }
}

class AssemblyProduct extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onClick.bind(this));
  }

  onClick(e) {
    this.hideInstructions();
    const productId = this.dataset.productId || e.target.dataset.productId;
    const category = this.dataset.category;

    if (productId) {
      this.showInstructions(productId);

      // Update URL params when product is selected
      try {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (category) {
          params.set("category", category);
        }

        params.set("product", productId);

        url.search = params.toString();
        window.history.replaceState({}, "", url.toString());
      } catch (error) {
        // Silently fail if URL APIs are not available
        console.error(error);
      }
    }

    document.getElementById("assembly-instructions").scrollIntoView();
  }

  hideInstructions() {
    document
      .querySelectorAll(".assembly-instructions")
      .forEach((node) => node.classList.add("assembly-instructions--hidden"));
  }

  showInstructions(productId) {
    document
      .querySelectorAll(
        `.assembly-instructions[data-product-id="${productId}"]`
      )
      .forEach((node) =>
        node.classList.remove("assembly-instructions--hidden")
      );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("assembly-products-list"))
    customElements.define("assembly-products-list", AssemblyProductsList);

  if (!customElements.get("assembly-product"))
    customElements.define("assembly-product", AssemblyProduct);

  // Wire up category dropdown change events
  document
    .querySelectorAll(".assembly-category-dropdown__select")
    .forEach((dropdown) => {
      dropdown.addEventListener("change", () => {
        dropdown.dispatchEvent(
          new Event("AssemblyCategoryDropdown:change", {
            bubbles: true,
          })
        );
      });
    });

  // Initialize state from URL params (deep linking)
  try {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const categoryParam = params.get("category");
    const productParam = params.get("product");

    const productsList = document.querySelector("assembly-products-list");
    const dropdown = document.querySelector(".assembly-category-dropdown__select");

    // Helper: select a specific product and scroll into view
    const selectProductById = (productId) => {
      if (!productId) return;

      const productEl = document.querySelector(
        `assembly-product[data-product-id="${productId}"]`
      );

      if (productEl && typeof productEl.hideInstructions === "function") {
        productEl.hideInstructions();
        productEl.showInstructions(productId);

        const instructions = document.getElementById("assembly-instructions");
        if (instructions) instructions.scrollIntoView();
      }
    };

    // If only product is given, infer its category first
    if (!categoryParam && productParam) {
      const productEl = document.querySelector(
        `assembly-product[data-product-id="${productParam}"]`
      );
      const inferredCategory = productEl?.dataset?.category;

      if (inferredCategory && dropdown) {
        dropdown.value = inferredCategory;
      }

      if (productsList && inferredCategory) {
        productsList.hideProducts();
        productsList.showProducts(inferredCategory);
      }

      selectProductById(productParam);
      return;
    }

    // Handle category from URL, with optional product
    if (categoryParam && dropdown && productsList) {
      // Set dropdown without triggering change handler
      dropdown.value = categoryParam;

      // Show the right category's products
      productsList.hideProducts();
      productsList.showProducts(categoryParam);

      if (productParam) {
        // Show the specific product instructions
        selectProductById(productParam);
      } else {
        // Default to first product in category
        productsList.selectFirstProduct(categoryParam);
      }
    }
  } catch (e) {
    // Fail silently if URL API is not available
    console.error(e);
  }
});
